module.exports = __webpack_public_path__ + "static/media/porto.81ab65da.jpeg";